<template>
  <div
    id="grocery-lists"
    class="page-content"
  >
    <div class="row">
      <div class="col-12">
        <grocery-list-search
          ref="groceryListSearchRef"
          @edit="onEditList"
          @create="onCreateList"
        />
      </div>
      <div
        v-if="editorState.isVisible"
        class="col-12"
      >
        <grocery-list-editor
          :list="editorState.list"
          :caller-id="editorState.callerId"
          @saved="onEditorSaved"
          @cancel="closeEditor"
          @refresh="onEditorRefresh"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref, defineAsyncComponent } from 'vue';
import type { GroceryList } from '@/services/groceryList/fetchGroceryLists';

const GroceryListSearch = defineAsyncComponent(
  () => import('./Grocery/GroceryListBuilder/GroceryListSearch.vue') as any,
);

const GroceryListEditor = defineAsyncComponent(
  () => import('./Grocery/GroceryListBuilder/GroceryListEditor.vue') as any,
);

interface GroceryListSearchRef {
  refreshGroceryLists: () => Promise<void>;
}

const groceryListSearchRef = ref<GroceryListSearchRef | null>(null);

const editorState = reactive<{
  isVisible: boolean;
  list: GroceryList | null;
  callerId: string;
}>({
  isVisible: false,
  list: null,
  callerId: '',
});

const onEditList = (list: GroceryList) => {
  editorState.isVisible = true;
  editorState.list = list;
  editorState.callerId = list.callerId;
};

const onCreateList = (callerId: string) => {
  editorState.isVisible = true;
  editorState.list = null;
  editorState.callerId = callerId;
};

const closeEditor = () => {
  editorState.isVisible = false;
  editorState.list = null;
  editorState.callerId = '';
};

const onEditorSaved = () => {
  closeEditor();
};

const onEditorRefresh = () => {
  groceryListSearchRef.value?.refreshGroceryLists();
};
</script>
